import '../App.css';

function ContactButton() {
    return (
        <div className='Contact-Button'>
            <button>
                Send
            </button>

        </div>
    )
}

export default ContactButton;